export const basicUrl = process.env.REACT_APP_BASIC_URL_WEB;
export const basicUrl2 = process.env.REACT_APP_BASIC_URL_MANGEMENT;
export const buzzOneUrl = process.env.REACT_APP_BASIC_URL_BUZZ_ONE_V1;
export const buzzNotificationUrl =
  process.env.REACT_APP_BASIC_URL_BUZZ_NOTIFICATION;
export const buzzUrl = process.env.REACT_APP_BASIC_URL_BUZZ;

export const hashTags = [
  'School Life',
  'Parenting',
  'Self Study',
  'Exams',
  'Extra Curricular',
  'Sports',
  'Annual Day',
  'Achievement',
  'Celebration',
];

export const postType = ['image', 'blog'];
export const sortBy = ['week', 'month', 'year'];

export const schoolId = '605b067c75f861c3ece0c8c5';
export const CITY = 'KolKata';
// export const userId = '605b38710a6ce2d0d5355676';

// export const user_id = '605b030675f861c3ece0c8b9'; // Chandan's User Id

export const generateArrayOfYears = (start, end) => {
  const max = start || new Date().getFullYear();
  const min = end;
  const years = [];
  for (let i = max; i >= min; i--) {
    years.push(i);
  }
  return years;
};

export const forClasses = [
  'Playgroup',
  'Nursery',
  'KG',
  'Senior KG',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
];

export const capitalize = (s) => {
  if (typeof s !== 'string') return s;
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const months = [
  'JANUARY',
  'FEBRUARY',
  'MARCH',
  'APRIL',
  'MAY',
  'JUNE',
  'JULY',
  'AUGUST',
  'SEPTEMBER',
  'OCTOBER',
  'NOVEMBER',
  'DECEMBER',
];
